var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8717 9L5.1257 5.382C4.9997 5.112 4.6397 4.842 4.5857 4.788C4.6397 4.734 4.9817 4.464 5.1257 4.194L6.7817 0.917999H4.9277L3.8117 3.42C3.7037 3.654 3.4877 3.87 3.4877 3.87C3.4877 3.87 3.2717 3.654 3.1637 3.42L2.0477 0.917999H0.193695L1.8677 4.194C2.0117 4.464 2.3537 4.734 2.4077 4.788C2.3537 4.842 1.9937 5.112 1.8677 5.382L0.121695 9H1.9757L3.1637 6.156C3.2717 5.904 3.5057 5.688 3.5057 5.688C3.5057 5.688 3.7217 5.904 3.8297 6.156L5.0177 9H6.8717Z",
    fill: "#7A8D9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.dcc3c39ec29128835e41aaea3ce57c69.svg";
export { ForwardRef as ReactComponent };